mutation RequestUserImageUploadUrl($input: RequestUserImageUploadUrlInput!) {
  requestUserImageUploadUrl(input: $input) {
    uploadUrl
    s3Key
    expiresAt
  }
}
